import {Component, Input} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'app-pulse-loading',
  standalone: true,
  imports: [
    NgIf,
    NgClass
  ],
  templateUrl: './pulse-loading.component.html',
  styleUrl: './pulse-loading.component.scss'
})
export class PulseLoadingComponent {
  @Input() status: 'completed' | 'loading' | 'error' | string = 'loading';
  @Input() color: string = 'violet-500';
  @Input() size: string = 'size-3';
}
